import service from "@/store/services/engineers";

const state = {
  list: {},
  page: {},
  engineer: {},
  meta: {},
  logo: null
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_PAGE: (state, page) => {
    state.page = page;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_ENGINEER: (state, engineer) => {
    state.engineer = engineer;
  }
};

const actions = {
  list({commit, dispatch}, params) {  
    return service.list(params)
      .then(({list, meta, page}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
        commit('SET_PAGE', page);
      });
  },

  get({commit, dispatch}, {id}) {
    return service.get(id)
      .then((engineer) => { commit('SET_ENGINEER', engineer); });
  },

  contact({commit, dispatch}, {id, params}) {
    return service.contact(id, params);
  },
};

const getters = {
  list: state => state.list,
  listTotal: state => state.page.total,
  engineer: state => state.engineer,
};

const engineers = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default engineers;
